// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d7856aa","453":"017a1f31","455":"cbc6819d"}[chunkId] + ".chunk.js";
};